<template lang="html">
  <material-card
    color='busie'
    :title='title'
    :text='text'>
    <v-stepper
      @input="$emit('input', $event)"
      :value='value'
      :vertical='vertical'>
      <slot>
        <step/>
      </slot>
    </v-stepper>
  </material-card>
</template>

<script>
import Step from './Step'
export default {
  components: {
    step: Step
  },
  props: {
    value: Number,
    title: {
      type: String,
      default: 'Default Title'
    },
    text: {
      type: String,
      default: 'Some text here'
    },
    vertical: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="css" scoped>
</style>
